import React from 'react';
import { Box, MenuItem, TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { adminActions, AdminFilters } from 'features/feedback/store/admin.slice';
import { ALL_STATUSES, BUG_AREA_LABEL, STATUS_STYLE, TYPE_LABEL } from 'features/feedback/shared/feedback.types';

const TriageFilters: React.FC = () => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector((s) => s.admin.filters);
  const set = (key: keyof AdminFilters, value: string) => dispatch(adminActions.setFilter({ key, value }));

  return (
    <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mb: 2 }}>
      <TextField select size="small" label="Тип" value={filters.type} onChange={(e) => set('type', e.target.value)} sx={{ minWidth: 140 }}>
        <MenuItem value="ALL">Усі типи</MenuItem>
        {(['BUG', 'REVIEW', 'IDEA'] as const).map((t) => <MenuItem key={t} value={t}>{TYPE_LABEL[t]}</MenuItem>)}
      </TextField>
      <TextField select size="small" label="Статус" value={filters.status} onChange={(e) => set('status', e.target.value)} sx={{ minWidth: 160 }}>
        <MenuItem value="ALL">Усі статуси</MenuItem>
        {ALL_STATUSES.map((st) => <MenuItem key={st} value={st}>{STATUS_STYLE[st].label}</MenuItem>)}
      </TextField>
      <TextField select size="small" label="Область" value={filters.area} onChange={(e) => set('area', e.target.value)} sx={{ minWidth: 140 }}>
        <MenuItem value="ALL">Усі області</MenuItem>
        {(['BACKEND', 'FRONTEND', 'CONTENT'] as const).map((a) => <MenuItem key={a} value={a}>{BUG_AREA_LABEL[a]}</MenuItem>)}
      </TextField>
    </Box>
  );
};

export default TriageFilters;
